var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeadForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5170_47634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 8.75C2.64036 8.75 2.08203 9.30833 2.08203 10C2.08203 10.6917 2.64036 11.25 3.33203 11.25C4.0237 11.25 4.58203 10.6917 4.58203 10C4.58203 9.30833 4.0237 8.75 3.33203 8.75ZM3.33203 3.75C2.64036 3.75 2.08203 4.30833 2.08203 5C2.08203 5.69167 2.64036 6.25 3.33203 6.25C4.0237 6.25 4.58203 5.69167 4.58203 5C4.58203 4.30833 4.0237 3.75 3.33203 3.75ZM3.33203 13.75C2.64036 13.75 2.08203 14.3167 2.08203 15C2.08203 15.6833 2.6487 16.25 3.33203 16.25C4.01536 16.25 4.58203 15.6833 4.58203 15C4.58203 14.3167 4.0237 13.75 3.33203 13.75ZM5.83203 15.8333H17.4987V14.1667H5.83203V15.8333ZM5.83203 10.8333H17.4987V9.16667H5.83203V10.8333ZM5.83203 4.16667V5.83333H17.4987V4.16667H5.83203Z",
    fill: "#2990FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5170_47634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadForm);
export default __webpack_public_path__ + "static/media/leadForm.ecc11c868a7551ec2a100a8b94422554.svg";
export { ForwardRef as ReactComponent };